module.exports = __webpack_public_path__ + "img/plaquette2.669dbf91.jpg";